import {Content} from "pdfmake/interfaces";
import {ShelvingInterface} from "../../../../store";
import {getSideShelvingSystemPage} from "./sideShelvingSystemPage/getSideShelvingSystemPage";


export const getShelvingSystemPages = (allShelving: ShelvingInterface): Array<Content> => {
    const showContent: Content = []
    Object.values(allShelving).forEach((shelving) => {
        if (shelving.sections.length > 0) {
            showContent.push(getSideShelvingSystemPage(shelving, 'front'));
            showContent.push(getSideShelvingSystemPage(shelving, 'side'));
        }
    })
    return showContent
}
